import React, { useRef, useEffect } from "react";

const VideoPlayer = ({ videoUrl, onPlayerLoaded }) => {
  const playerRef = useRef(null);
  const previousUrlRef = useRef(videoUrl);

  useEffect(() => {
    // Only update if URL actually changed
    if (previousUrlRef.current !== videoUrl) {
      previousUrlRef.current = videoUrl;
    }
  }, [videoUrl]);

  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
      <iframe
        ref={playerRef}
        src={videoUrl}
        className="w-full h-full overflow-hidden"
        allow="autoplay; fullscreen"
        allowFullScreen
        scrolling="no"
        frameBorder="0"
        style={{ overflow: "hidden" }}
        title="Video Player"
        onLoad={() => {
          if (typeof onPlayerLoaded === "function") {
            try {
              onPlayerLoaded();
            } catch (_) {
              // no-op
            }
          }
        }}
      />
    </div>
  );
};

// Strict comparison of props
const MemoizedVideoPlayer = React.memo(VideoPlayer, (prevProps, nextProps) => {
  return prevProps.videoUrl === nextProps.videoUrl;
});

export default MemoizedVideoPlayer;
